// Module
var code = "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n    <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>\n        <span class=\"ib-tab__text-align\">{{heading}}</span>\n    </a>\n</li>";
// Exports
module.exports = code;